import React from 'react';

import './PartnersOthers.scss';

import { PartnerCard } from '../../';

class PartnersOthers extends React.PureComponent {
    renderPartners = () => {
        const partners = this.props.partners.list;

        return partners.map((partner, index) => {
            return <PartnerCard key={index} partner={partner}/>
        })
    };

    render() {
        const partners = this.props.partners;

        return (
            <section className="partnersOthers">
                <div className="container">
                    <h6 className="text-center">{partners.title}</h6>
                    <div className="row">
                        {this.renderPartners()}
                    </div>
                </div>
            </section>
        );

    }
}

export default PartnersOthers;


// WEBPACK FOOTER //
// ./src/components/Partners/PartnersOthers/PartnersOthers.js